export { default as LessonDetail } from "./LessonDetail";
export { default as LessonList } from "./LessonList";

